<header>
  <dx-toolbar class="header-toolbar">
    <dxi-item
      *ngIf="menuToggleEnabled"
      location="before"
      widget="dxButton"
      cssClass="menu-button"
      [options]="{
        icon: 'menu',
        stylingMode: 'text',
        onClick: toggleMenu
      }">
    </dxi-item>
    <dxi-item location="before" class="header-logo">
      <img [src]="'assets/icons/tp_logo_25.jpg'" alt="tp_logo_25" [ngClass]="{'mobile-logo': isMobile, 'desktop-logo': !isMobile}">
    </dxi-item>
    <dxi-item location="before" cssClass="user-name-selector">
      <div class="user-name-content" [title]="userName + (userSurname ? ' ' + userSurname : '')">
        <span *ngIf="userName || userSurname">{{ displayUserName }}</span>
      </div>
    </dxi-item>
    <dxi-item
      location="before"
      *ngIf="unreadMessageCount > 0">
      <dx-button
      [text]="unreadMessageCount.toString()"
        icon="message"
        stylingMode="text"
        type="danger"
        (onClick)="navigateToMessages()">
      </dx-button>
    </dxi-item>
    <dxi-item
      location="after"
      locateInMenu="auto"
      menuItemTemplate="menuItem">
      <div *dxTemplate="let data of 'item'">
        <dx-button
          class="user-button authorization"
          width="210px"
          height="100%"
          stylingMode="text">
          <div *dxTemplate="let data of 'content'">
            <app-user-panel [user]="user" [menuItems]="userMenuItems" menuMode="context"></app-user-panel>
          </div>
        </dx-button>
      </div>
    </dxi-item>
    <div *dxTemplate="let data of 'menuItem'">
      <app-user-panel [user]="user" [menuItems]="userMenuItems" menuMode="list"></app-user-panel>
    </div>
  </dx-toolbar>
</header>